import { render, staticRenderFns } from "./MusicInterest.vue?vue&type=template&id=a2e963ae&scoped=true&"
import script from "./MusicInterest.vue?vue&type=script&lang=js&"
export * from "./MusicInterest.vue?vue&type=script&lang=js&"
import style0 from "./MusicInterest.vue?vue&type=style&index=0&id=a2e963ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e963ae",
  null
  
)

export default component.exports